module.exports = __webpack_public_path__ + "img/ask.fedacbd6.svg";